const mapping = {
  enhanced: [
    'actions',
    'memo',
    'isActive',
    'number',
    'entity',
    'entityType',
    'hankenoEntity',
    'paymentTerm',
    'deliveryTerms',
    // 'mainContactName',
    // 'mainContactRole',
    // 'mainContactPhoneNumber',
    // 'mainContactEmail',
  ],
  simple: [
    'number',
    'entity',
    'entityType',
    'paymentTerm',
    'deliveryTerms',
    'mainContactName',
    'mainContactRole',
    'mainContactPhoneNumber',
    'mainContactEmail',
    'hankenoEntity',
  ],
  collasped: [
    'number',
    'entity',
    'hankenoEntity',
    'paymentTerm',
    'deliveryTerm',
  ],
}

export default mapping
